export const quotas = {
    Free: {
      storage: Infinity, user: Infinity, productType: Infinity, product: Infinity, discount: Infinity, cashier: Infinity,
      exportPDF: true, reports: 'ALL', backup: true,
    },
    Starter: {
      storage: Infinity, user: Infinity, productType: Infinity, product: Infinity, discount: Infinity, cashier: Infinity,
      exportPDF: true, reports: 'ALL', backup: true,
    },
    Plus: {
      storage: Infinity, user: Infinity, productType: Infinity, product: Infinity, discount: Infinity, cashier: Infinity,
      exportPDF: true, reports: 'ALL', backup: true,
    },
    Premium: {
      storage: Infinity, user: Infinity, productType: Infinity, product: Infinity, discount: Infinity, cashier: Infinity,
      exportPDF: true, reports: 'ALL', backup: true,
    },
    CashMate: {
      storage: Infinity,
      user: Infinity,
      productType: Infinity,
      product: Infinity,
      discount: Infinity,
      cashier: Infinity,
      exportPDF: true,
      reports: 'ALL',
      backup: true,
    },
  };
